<template>
  <div ref="root" class="loader">
    <div class="loader__spinner" />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.loader {
  @include centering;

  &__spinner {
    @include loader(48px);
  }
}
</style>
